import { Injectable } from '@angular/core';
import { HhsgSharedApplication } from '../models/application.model';
import { HhsgSharedClient } from '../models/client.model';
import { HhsgSharedConfigService } from './config.service';

import { HhsgSharedHttpService } from './http.service';

@Injectable()
export class HhsgSharedAdminService {
	_controllerName: string = 'ClientAdmin';
    private readonly _apiServer: string;

	constructor(
        private _configService: HhsgSharedConfigService,
        private _httpService: HhsgSharedHttpService) {
        this._apiServer = _configService.appSettings.stsServer;
    }

	async getAllActiveClientsForImporter(applicationAbbreviation: string): Promise<HhsgSharedClient[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedClient[]>(this._apiServer,this._controllerName, `GetActiveClientsByApplication/${applicationAbbreviation}`);
	}

	async getFileImportTaskEnabledCorporationsForUserByApplication(applicationAbbreviation: string): Promise<any[]> {
		return this._httpService.doGetRequestAsync<any[]>(this._apiServer,'Corporations', `GetFileImportTaskEnabledCorporationsForUserByApplication/${applicationAbbreviation}`);
	}
}
